export default "__VITE_ASSET__f050bb42__"